import { degToRad, radToDeg } from '@/util/math';

/** Clinically meaningful ranges for cup orientation angles (degrees). */
export const MIN_INCLINATION = 20;
export const MAX_INCLINATION = 60;
export const MIN_ANTEVERSION = 0;
export const MAX_ANTEVERSION = 40;

/** Angle as given in */
export type AnteversionInclination = {
    /** Anteversion angle  */
    anteversion: number;

    /** Inclination angle */
    inclination: number;
};

/** The two rotation axes of an anteversion/inclination pair. */
export type AnteversionInclinationAxis = keyof AnteversionInclination;

/** Convert a set of acetabular-angles from radians to degrees */
export function toDegrees<T extends AnteversionInclination>(angles: T): T {
    return {
        ...angles,
        anteversion: radToDeg(angles.anteversion),
        inclination: radToDeg(angles.inclination),
    };
}

/** Convert a set of acetabular-angles from degrees to radians */
export function toRadians<T extends AnteversionInclination>(angles: T): T {
    return {
        ...angles,
        anteversion: degToRad(angles.anteversion),
        inclination: degToRad(angles.inclination),
    };
}
